/* Copyright (C) ZibatRan, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Zibatran development team, Dec 2020
 */

import React from 'react';
import Header from '../../global/navs/Header'
import MyFooter from "../../global/navs/MyFooter";

const PublicLayout = ({children}) => {
    const [userData,setUserData]=React.useState();

    return (
        <>
            <header className="sticky-top">
                <div className="top-bar d-none">
                    <div>
                        <span>بازار هوشمند آموزش</span>
                    </div>
                </div>
                <Header/>
            </header>
            {/*<main className="publicContainer">*/}
            <main className="container">
            {/*<main className=" p-0 m-0">*/}
                {children}
            </main>
            <MyFooter/>
        </>
    );

};

export default PublicLayout;